export default __webpack_public_path__ + "static/media/s7.93612f26.jpg";